import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";

export const getContactListApiCall = createAsyncThunk("contactList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: contactList } = await API.getContactListApi(submitData);
        //console.log('data ***********:', contactList);
        
        dispatch(setLoader(false))
        return contactList;
    } catch (error) {
        throw error;
    }
});

// export const editContactDataApiCall = createAsyncThunk("editContactData", async (submitData, { dispatch }) => {
//     try {
//         dispatch(setLoader(true))
//         const { data: editContactData, code, message } = await API.editContactApi(submitData);
//         if (code === '1') {
//             TOAST_SUCCESS(message);
//         }
//         dispatch(setLoader(false))
//         return { data: editContactData, code, message };
//     } catch (error) {
//         throw error;
//     }
// });

const initialState = {
    contactList: {
        data: [],
        error: null,
    },
    editContactData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const contactSlice = createSlice({
    name: "CONTACT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getContactListApiCall.fulfilled, (state, action) => {
                state.contactList.data = action.payload;
            })
            .addCase(getContactListApiCall.rejected, (state, action) => {
                state.contactList.error = action.error.message;
            })
            // .addCase(editContactDataApiCall.fulfilled, (state, action) => {
            //     const { message, code, data } = action.payload;
            //     state.editContactData.data = data;
            //     state.editContactData.message = message;
            //     state.editContactData.code = code;
            // })
            // .addCase(editContactDataApiCall.rejected, (state, action) => {
            //     state.editContactData.error = action.error.message;
            // });
    },
});

export default contactSlice.reducer;